<button class="w-12 flex flex-middle"
        [class.pe-none]="hideSelector"
        (click)="toggle([toggleGroup, 1])">
    <multisite-flag class="flex"
                    [simpleMultisite]="true"
                    [siteId]="current.siteId">
    </multisite-flag>

    @if (!hideSelector) {
    <i class="icon-chevron is-down inline-flex"
       [style.fontSize.px]="18"
       [toggleClassBy]="[toggleGroup, 1]"
       [toggleClass]="'is-up !is-down'">
    </i>
    }
</button>
<div class="hide-up-container pos-absolute m-t-2">
    <div #hideUpElSimple
         class="hide-up hide-up-top ng-hide ng-hide-animate bg-col-w b-a"
         [toggleClass]="'!ng-hide'"
         [toggleClassBy]="[toggleGroup, 1]">
        @for (item of sites; track $index) {
        <a class="flex flex-middle flex-justify-left p-t-2 p-b-2 p-l-2 p-r-2"
           (click)="goTo(item.siteId,$event)">
            <!-- current.country -->
            <multisite-flag class="flex m-r-1"
                            [siteId]="item.siteId"
                            [ngStyle]="item.siteId === current.siteId ? {'opacity': '1'} : {'opacity': '0.5'}"
                            [dropDownFlag]="true"></multisite-flag>
        </a>
        }
    </div>
</div>
